module.exports = __webpack_public_path__ + "static/media/semiTractorWithTrailer_green.6a81ce48.svg";